// Angular
import { Injectable } from '@angular/core';
import { AbstractControl, ValidatorFn } from '@angular/forms';

@Injectable({
	providedIn: 'root',
})
export class ValidationService {
	constructor() {}

	static decimalValidation(decimalPlaces: number): ValidatorFn {
		return (control: AbstractControl) => {
			if (!control.value || control.value.length == 0 || this.regExDecimalMatch(control.value, decimalPlaces)) {
				return null;
			} else {
				return { decimalValidation: true };
			}
		};
	}

	static regExDecimalMatch(value: number, decimalPlaces: number) {
		var regExp = new RegExp(`^\-?[0-9]+(?:\.[0-9]{1,${decimalPlaces}})?$`);
		return String(value).match(regExp);
	}
}
